<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ data.modalType }} Out Of State Registration</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="spinner" *ngIf="true != dataLoaded"></div>
    <form [formGroup]="form" *ngIf="true == dataLoaded" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required" for="plateNumber">Plate Number</label>
                    <input maxlength="10" formControlName="plateNumber" id="plateNumber" class="mvd_form-control" type="text"/>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required" for="jurisdictionId">Plate State</label>
                    <select class="mvd_form-control" formControlName="jurisdictionId">
                        <option value="0">- Select -</option>
                        <option *ngFor="let jurisdiction of jurisdictions" [value]="jurisdiction.id">{{ jurisdiction.displayValue }}</option>
                    </select>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-3 mvd_form-group">
                    <label class="required" title="* Required" for="expirationDate">Expiration Date</label>
                    <max-calendar showIcon="true"  hourFormat="12" formControlName="expirationDate"></max-calendar>
                    <control-validation-messages control="expirationDate"></control-validation-messages>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button *ngIf="!edit" class="btn--primary" type="submit" [disabled]="true != form.valid" (click)="save()">Add</button>
        <button *ngIf="edit" class="btn--primary" type="submit" [disabled]="true != form.valid" (click)="save()">Save</button>
    </div>
</div>